export default "__VITE_ASSET__DDrkW6BJ__"